import { useQuery } from "react-query";
import { getProjectTypes } from "../../services/scientific/projectType";
import { PagedRequestType } from "../../types/PagedResults";
import { Key_projectTypes, PROJECT_TYPES } from "../../utils/constants";


export const useGetProjectTypesQuery = (data: PagedRequestType) =>
  useQuery(
    [Key_projectTypes, JSON.stringify(data)],
    () => getProjectTypes(data)
  );
